class NexusCollectionRequest {
  static version = 0;
  static controller = null;
  static pendingUrl = null;
  static async render(url, id, owner, mobile = false) {
    const request = new URL(url, window.location.origin);
    request.searchParams.delete('page');
    request.searchParams.set('sections', id);
    const clean = new URL(request);
    clean.searchParams.delete('sections');
    clean.searchParams.delete('section_id');
    this.pendingUrl = clean.toString();
    const version = ++this.version;
    this.controller?.abort();
    this.controller = new AbortController();
    try {
      const response = await fetch(request.toString(), { signal: this.controller.signal });
      if (!response.ok) throw new Error('Filter request failed');
      const sections = await response.json();
      if (version !== this.version) return;
      if (!sections[id]) throw new Error('Missing filter section');
      const temp = document.createElement('div');
      temp.innerHTML = sections[id];
      if (!temp.querySelector('.coll_main_main_inner')) throw new Error('Missing product grid');
      for (const selector of ['.coll_main_main_inner', '.collection_products_count', '.mobile_filter_drawer']) {
        const oldElement = document.querySelector(selector);
        const newElement = temp.querySelector(selector);
        if (oldElement && newElement) oldElement.innerHTML = newElement.innerHTML;
      }
      document.querySelectorAll('select[name="sort_by"]').forEach(select => {
        const value = clean.searchParams.get('sort_by');
        if (value) select.value = value;
      });
      history.pushState({}, '', clean.toString());
      document.dispatchEvent(new CustomEvent('collection-grid-update', { detail: { url: clean.toString(), sectionId: id } }));
      if (mobile) closeDrawer(document.querySelector('.mobile_filter_drawer'));
    } catch (error) {
      if (version === this.version && error.name !== 'AbortError') window.location.assign(clean.toString());
    } finally {
      if (version === this.version) { this.pendingUrl = null; owner.hideLoader(); }
    }
  }
}


class CollectionSorting extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form#coll_main_sorting_form');
    this.select = this.querySelector('select[name="sort_by"]');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.select.addEventListener('change', () => {
      const value = this.select.value;

      this.showLoader();

      const url = new URL(NexusCollectionRequest.pendingUrl || window.location.href, window.location.origin);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url, this.sectionId);     


    }) 
  }

  showLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');

    if(loader) {
      loader.classList.remove('hidden');
    }

    this.select.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');

    if(loader) {
      loader.classList.add('hidden');
    }

    this.select.disabled = false;
  }

  updatePage(url, id) { return NexusCollectionRequest.render(url, id, this); }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString())
  }
}

customElements.define('collection-sorting', CollectionSorting);


class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[type="checkbox"]');
    this.priceInputs = this.querySelectorAll('input[type="number"]');
    this.sectionId = this.dataset.sectionId;
    this.sortSelect = document.querySelector('select[name="sort_by"]');
    this.activeTags = this.querySelectorAll('.active_values_wrapper a');
  }

  connectedCallback() {
    this.bindCheckboxFilters();
    this.bindPriceInputs();
    this.bindActiveValueRemoval();
  }

  bindCheckboxFilters() {
    this.inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.showLoader();

        const url = new URL(NexusCollectionRequest.pendingUrl || window.location.href);
        const names = new Set([...this.inputs].map(input => input.name));
        names.forEach(name => url.searchParams.delete(name));
        this.inputs.forEach(input => { if (input.checked) url.searchParams.append(input.name, input.value); });

        url.searchParams.set('sections', this.sectionId);

        this.updatePage(url);
  
      });
    });
  }

  bindPriceInputs() {
    const debouncedHandler = debounce(() => {
      this.showLoader();

      const url = new URL(NexusCollectionRequest.pendingUrl || window.location.href);

      this.priceInputs.forEach(input => {
        input.value
          ? url.searchParams.set(input.name, input.value)
          : url.searchParams.delete(input.name);
      });

      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url);

    }, 800);

    this.priceInputs.forEach(input => {
      input.addEventListener('input', debouncedHandler);
    });
  }

  bindActiveValueRemoval() {
    this.activeTags.forEach(tag => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        this.showLoader();

        const url = new URL(tag.getAttribute('href'), window.location.origin);
        url.searchParams.set('sections', this.sectionId);

        this.updatePage(url);
  
      });
    });
  }

  updatePage(url) { return NexusCollectionRequest.render(url, this.sectionId, this); }

  replaceContent(tempHTML, selector) {
    const newEl = tempHTML.querySelector(selector);
    const oldEl = document.querySelector(selector);
    if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    history.pushState({}, '', url.toString());
  }

  showLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if (loader) loader.classList.remove('hidden');
    if (this.sortSelect) this.sortSelect.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if (loader) loader.classList.add('hidden');
    if (this.sortSelect) this.sortSelect.disabled = false;
  }
}

customElements.define('collection-filters', CollectionFilters);

function debounce(fn, delay = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


class MobileFilters extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector('.coll_main_grid_wrapper .loader');
    this.collectionGrid = document.querySelector('.coll_main_main_inner');
    this.btn = this.querySelector('.mobile_filters_btn button');
    this.form = this.querySelector('form#mobile_filters_form');
    this.drawer = document.querySelector('.mobile_filter_drawer');
    this.activeValues = this.querySelectorAll('.mob_active_values_wrapper a');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    if(this.btn) {
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        if(!this.form || !this.collectionGrid) return;

        this.showLoader();
        this.submitForm();
      })
    }    

    if(this.activeValues.length) {
    this.activeValues.forEach((value) => {
      value.addEventListener('click', (e) => {
        e.preventDefault();

        this.showLoader();

        const url = new URL(e.currentTarget.getAttribute('href'), window.location.href);


        this.updatePage(url.toString(), this.sectionId);

      })
    })
  }
  }

  showLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  async submitForm() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);
    const hasSortBy = formData.has('sort_by');

    for(const [key, value] of currentParams.entries()) {
      if(key !== 'page' && key !== 'sections' && !key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if(key === 'sort_by' && hasSortBy) {
          continue;
        }
        params.append(key,  value);
      }
    }

    for(const [key, value] of formData.entries()) {
      if(value && value != "") {
        if(key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    const url = `${window.location.pathname}?${params.toString()}`;


    await this.updatePage(url, this.sectionId);
  }  

  async updateURL(url) {
    history.pushState(null, "", url);
  }

  async updatePage(url, id) { return NexusCollectionRequest.render(url, id, this, true); }

}

customElements.define('mobile-filters', MobileFilters);

class SearchResetButton extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form[role="search"]');
    this.btn = this.querySelector('.button_reset');    
  }

  connectedCallback() {
    this.btn.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    const url = new URL(NexusCollectionRequest.pendingUrl || window.location.href);
    url.search = '';
    window.location.href = url.toString();
  }
}

customElements.define('search-reset-button', SearchResetButton);

